// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/fonts/Mulish-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/fonts/RadioCanada-VariableFont_wdth,wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

/* Aplica el estilo a toda la página */
html, body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-y: auto; /* Permite el desplazamiento */
  overflow-x: hidden; /* Evita el desplazamiento horizontal */
}


body::-webkit-scrollbar {
  display: none;
}

body {
  scrollbar-width: none; /* Para Firefox */
  overflow-y: scroll; /* Asegura el scroll sin scrollbar */
}


.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.animate-blur-custom {
  background-color: #ecf0f350; /* Color de fondo con transparencia */
  backdrop-filter: blur(10px); /* Aplica un desenfoque al fondo */
  /* Si deseas soporte más amplio, también puedes usar lo siguiente */
  -webkit-backdrop-filter: blur(10px); /* Para navegadores WebKit como Safari */
}


@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@font-face {
  font-family: mulish;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.mulish{
  font-family: mulish;
}

@font-face {
  font-family: radio_canada;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.radio_canada{
  font-family: radio_canada;
}

/* Estilos para ocultar el scrollbar */
.hide-scrollbar {
  overflow-y: auto;
  scrollbar-width: none; /* Para Firefox */
}

.hide-scrollbar::-webkit-scrollbar {
  display: none !important;
}

/* Para ocultar el scrollbar en navegadores basados en WebKit (Chrome, Safari, Edge) */
.scrollbar-hidden::-webkit-scrollbar {
  width: 0px; /* Oculta el scrollbar horizontal */
  height: 0px; /* Oculta el scrollbar vertical */
  display: none;
}

/* Para Firefox */
.scrollbar-hidden {
  scrollbar-width: none;
}

/* Para Internet Explorer y Edge */
.scrollbar-hidden {
  -ms-overflow-style: none;
}

/* Scrollbar para WebKit (Chrome, Safari, Edge) */
::-webkit-scrollbar {
  width: 0px; /* Ancho del scrollbar */
}

::-webkit-scrollbar-thumb {
  background-color: #F4EEE3; /* Color del "botón" del scrollbar */
  border-radius: 10px; /* Bordes redondeados */
}

::-webkit-scrollbar-track {
  background: #f1f1f1; /* Color de fondo del scrollbar */
}

@keyframes breathingGlow {
  0% {
    transform: scale(0.88);
    opacity: 0.2;
    filter: blur(1px) brightness(0.8);
  }

  12% {
    transform: scale(0.91);
    opacity: 0.24;
  }

  38% {
    transform: scale(1.05);
    opacity: 0.38;
  }

  48% {
    transform: scale(1.1);
    opacity: 0.45;
    filter: blur(4px) brightness(0.85);
  }

  54% {
    transform: scale(1.1);
    opacity: 0.45;
    filter: blur(4px) brightness(0.85);
  }

  68% {
    transform: scale(1.04);
    opacity: 0.36;
  }

  90% {
    transform: scale(0.91);
    opacity: 0.23;
  }

  100% {
    transform: scale(0.88);
    opacity: 0.2;
    filter: blur(1px) brightness(0.8);
  }
}

.breathing-glow {
  transform-origin: center center;
  animation: breathingGlow 6s cubic-bezier(0.37, 0, 0.63, 1) infinite;
  will-change: transform, opacity, filter;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB,EAAE,8BAA8B;EAChD,kBAAkB,EAAE,uCAAuC;AAC7D;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB,EAAE,iBAAiB;EACxC,kBAAkB,EAAE,oCAAoC;AAC1D;;;AAGA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,2BAA2B,EAAE,qCAAqC;EAClE,2BAA2B,EAAE,kCAAkC;EAC/D,mEAAmE;EACnE,mCAAmC,EAAE,wCAAwC;AAC/E;;;AAGA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,mBAAmB;EACnB,4CAAmD;AACrD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,4CAA8D;AAChE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,qBAAqB,EAAE,iBAAiB;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sFAAsF;AACtF;EACE,UAAU,EAAE,mCAAmC;EAC/C,WAAW,EAAE,iCAAiC;EAC9C,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,wBAAwB;AAC1B;;AAEA,iDAAiD;AACjD;EACE,UAAU,EAAE,wBAAwB;AACtC;;AAEA;EACE,yBAAyB,EAAE,oCAAoC;EAC/D,mBAAmB,EAAE,uBAAuB;AAC9C;;AAEA;EACE,mBAAmB,EAAE,iCAAiC;AACxD;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,aAAa;IACb,kCAAkC;EACpC;;EAEA;IACE,qBAAqB;IACrB,aAAa;IACb,kCAAkC;EACpC;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,iCAAiC;EACnC;AACF;;AAEA;EACE,+BAA+B;EAC/B,mEAAmE;EACnE,uCAAuC;AACzC","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n/* Aplica el estilo a toda la página */\nhtml, body {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow-y: auto; /* Permite el desplazamiento */\n  overflow-x: hidden; /* Evita el desplazamiento horizontal */\n}\n\n\nbody::-webkit-scrollbar {\n  display: none;\n}\n\nbody {\n  scrollbar-width: none; /* Para Firefox */\n  overflow-y: scroll; /* Asegura el scroll sin scrollbar */\n}\n\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.animate-blur-custom {\n  background-color: #ecf0f350; /* Color de fondo con transparencia */\n  backdrop-filter: blur(10px); /* Aplica un desenfoque al fondo */\n  /* Si deseas soporte más amplio, también puedes usar lo siguiente */\n  -webkit-backdrop-filter: blur(10px); /* Para navegadores WebKit como Safari */\n}\n\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@font-face {\n  font-family: mulish;\n  src: url(../src/fonts/Mulish-VariableFont_wght.ttf);\n}\n\n.mulish{\n  font-family: mulish;\n}\n\n@font-face {\n  font-family: radio_canada;\n  src: url(../src/fonts/RadioCanada-VariableFont_wdth\\,wght.ttf);\n}\n\n.radio_canada{\n  font-family: radio_canada;\n}\n\n/* Estilos para ocultar el scrollbar */\n.hide-scrollbar {\n  overflow-y: auto;\n  scrollbar-width: none; /* Para Firefox */\n}\n\n.hide-scrollbar::-webkit-scrollbar {\n  display: none !important;\n}\n\n/* Para ocultar el scrollbar en navegadores basados en WebKit (Chrome, Safari, Edge) */\n.scrollbar-hidden::-webkit-scrollbar {\n  width: 0px; /* Oculta el scrollbar horizontal */\n  height: 0px; /* Oculta el scrollbar vertical */\n  display: none;\n}\n\n/* Para Firefox */\n.scrollbar-hidden {\n  scrollbar-width: none;\n}\n\n/* Para Internet Explorer y Edge */\n.scrollbar-hidden {\n  -ms-overflow-style: none;\n}\n\n/* Scrollbar para WebKit (Chrome, Safari, Edge) */\n::-webkit-scrollbar {\n  width: 0px; /* Ancho del scrollbar */\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #F4EEE3; /* Color del \"botón\" del scrollbar */\n  border-radius: 10px; /* Bordes redondeados */\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1; /* Color de fondo del scrollbar */\n}\n\n@keyframes breathingGlow {\n  0% {\n    transform: scale(0.88);\n    opacity: 0.2;\n    filter: blur(1px) brightness(0.8);\n  }\n\n  12% {\n    transform: scale(0.91);\n    opacity: 0.24;\n  }\n\n  38% {\n    transform: scale(1.05);\n    opacity: 0.38;\n  }\n\n  48% {\n    transform: scale(1.1);\n    opacity: 0.45;\n    filter: blur(4px) brightness(0.85);\n  }\n\n  54% {\n    transform: scale(1.1);\n    opacity: 0.45;\n    filter: blur(4px) brightness(0.85);\n  }\n\n  68% {\n    transform: scale(1.04);\n    opacity: 0.36;\n  }\n\n  90% {\n    transform: scale(0.91);\n    opacity: 0.23;\n  }\n\n  100% {\n    transform: scale(0.88);\n    opacity: 0.2;\n    filter: blur(1px) brightness(0.8);\n  }\n}\n\n.breathing-glow {\n  transform-origin: center center;\n  animation: breathingGlow 6s cubic-bezier(0.37, 0, 0.63, 1) infinite;\n  will-change: transform, opacity, filter;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
